import { Injectable } from "@angular/core";
import { environment } from './../../environments/environment';

@Injectable()
export class Config {
    //private HOST = process.env.HOST || "http://10.0.0.4";
    //private PORT = process.env.PORT || 3000;
    //private API = process.env.API || 'api';

    //baseURL : string = "http://localhost:3000/json/";
    //public BaseURL: string = "http://10.0.0.8:3001/";
    //public BaseURL: string = "http://10.0.0.12:3000/api/";
    //public BaseURL: string = "http://10.0.0.4:3000/api/";
    //public BaseURL: string = "http://10.0.0.11:3001/api/";
    //public BaseURL: string = "http://10.0.0.7:3001/api/";
    //public BaseURL: string = "http://10.0.0.11:3001/api/";
    //public BaseURL: string = "http://103.226.185.2:3000/api/";
    //public BaseURL: string = "http://partner.myslbb.com/api/";
    //public BaseURL: string = "/api/";

    public BaseURL: string =   environment.API_URL;
    public SocketURL: string = environment.SOCKET_SERVER_URL; 
    
    //public BaseURL: string = "http://10.0.0.15:3001/api/";
    //public BaseURL: string = this.HOST + ":" + this.PORT + "/" + this.API + "/";
}